module.exports = __webpack_public_path__ + "img/logo.d9c097ac.png";